import script from "./LoadSearchLabelsMixin.vue?vue&type=script&lang=js"
export * from "./LoadSearchLabelsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__